import { render } from "./ModalRoom.vue?vue&type=template&id=1dd2e5e0"
import script from "./ModalRoom.vue?vue&type=script&lang=js"
export * from "./ModalRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__